<!-- <div class="location-finder">
  <div class="location-flex">
    <div class="scrollable map-container">
      <app-location-map [google]="google" [flow]="flow" #locationMap></app-location-map>
    </div>
    <div class="scrollable location-container">
        <app-location-search [flow]="flow" [labels]="locationLabels" [google]="google" #locationSearch></app-location-search>
        <app-location-search-result [flow]="flow" [labels]="locationLabels" (sendLocation)="onSendLocation($event)"></app-location-search-result>
    </div>
  </div>
</div> -->

<!-- <div class="location-finder-container">
  <div class="location-search-mobile">
    <div class="cont-loc-search">
      <app-location-search
        [flow]="flow"
        [labels]="labels"
        [google]="google"
        #locationSearch
      ></app-location-search>
    </div>
    <div class="title-close-container" (click)="close()">
      <img
        src="assets\images\close-black-icon.svg"
        alt="close-icon"
        class="close-button"
      />
    </div>
  </div>
  <div class="map-container">
    <app-location-map
      [google]="google"
      [flow]="flow"
      [labels]="sdfCardLabels"
      [originalAddressSearched]="originalAddressSearched"
      #locationMap
    ></app-location-map>
  </div>
  <div class="location-container">
    <div class="location-search-web">
      <app-location-search
        [flow]="flow"
        [labels]="labels"
        [google]="google"
        (search)="onSearch($event)"
        #locationSearch
      ></app-location-search>
    </div>
    <app-location-search-result
      [flow]="flow"
      [labels]="labels"
      (sendLocation)="onSendLocation($event)"
    ></app-location-search-result>
  </div>
</div> -->

<div class="app-locator-main-container">
  <div class="search-location-container">
    <app-location-search 
      [flow]="flow" 
      [labels]="labels" 
      [google]="google" 
      #locationSearch 
      (upOnClose)="close()"
      (basicSearchEvent)="onBasicSearch()"
    ></app-location-search>
    <!-- <app-location-search-result [flow]="flow" [labels]="labels"
      (sendLocation)="onSendLocation($event)"></app-location-search-result> -->
      <app-location-search-result
      [flow]="flow"
      [labels]="labels"
      [isViewMoreBtnHidden]="isViewMoreBtnHidden"
      [isTierFilteringEnabled]="isTierFilteringEnabled"
      (sendLocation)="onSendLocation($event)"
      (closeDailogOnSelLoc)="close()"
      (viewMoreEvent)="onViewMore()"
    ></app-location-search-result>

  </div>
  <div class="google-maps-location-container">
    <app-location-map 
      [google]="google" 
      [flow]="flow" 
      [labels]="sdfCardLabels"
      [originalAddressSearched]="originalAddressSearched" 
      #locationMap
      (basicSearchEvent)="onBasicSearch()"  
    ></app-location-map>
  </div>
</div>
